// extracted by mini-css-extract-plugin
export var grid = "_p-0";
export var span1 = "_p-2";
export var span10 = "_p-b";
export var span10L = "_p-z";
export var span10M = "_p-n";
export var span10Xl = "_p-1b";
export var span11 = "_p-c";
export var span11L = "_p-10";
export var span11M = "_p-o";
export var span11Xl = "_p-1c";
export var span12 = "_p-d";
export var span12L = "_p-11";
export var span12M = "_p-p";
export var span12Xl = "_p-1d";
export var span1L = "_p-q";
export var span1M = "_p-e";
export var span1Xl = "_p-12";
export var span2 = "_p-3";
export var span2L = "_p-r";
export var span2M = "_p-f";
export var span2Xl = "_p-13";
export var span3 = "_p-4";
export var span3L = "_p-s";
export var span3M = "_p-g";
export var span3Xl = "_p-14";
export var span4 = "_p-5";
export var span4L = "_p-t";
export var span4M = "_p-h";
export var span4Xl = "_p-15";
export var span5 = "_p-6";
export var span5L = "_p-u";
export var span5M = "_p-i";
export var span5Xl = "_p-16";
export var span6 = "_p-7";
export var span6L = "_p-v";
export var span6M = "_p-j";
export var span6Xl = "_p-17";
export var span7 = "_p-8";
export var span7L = "_p-w";
export var span7M = "_p-k";
export var span7Xl = "_p-18";
export var span8 = "_p-9";
export var span8L = "_p-x";
export var span8M = "_p-l";
export var span8Xl = "_p-19";
export var span9 = "_p-a";
export var span9L = "_p-y";
export var span9M = "_p-m";
export var span9Xl = "_p-1a";
export var stretch = "_p-1";